module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The author would like to express his personal thanks to the following: The National Archives, Imperial War Museum, Aberdeen City and Aberdeenshire Archives, Manx National Heritage Library and Archives, Newcastle Local Studies Library, Gerry Jackson, BBC Look North, BBC Radio Norfolk, MVC Studios, Norfolk Record Office, Lizzy Baker, Archives Lead, Tyne & Wear Archives, German Occupation Museum, Guernsey, Milton Keynes Museum, Lieutenant Colonel Martin Valles, Kim Valles, David Hepworth, Derek Tree, John Warwicker, Richard Underwood, David Schrader, Tim Bennett, Steve and Eve Bacon, David and Christine Parmenter, Ian Johnson, Marc Hope, Richard Cobb, Ellengard Gertz, Oliver Rogge, Mark Cudworth, Susanne Köhler, Austin Ruddy, Michelle Bullivant, Henry Wilson, Matt Jones, Irene Moore, my old friends Stewart P. Evans, Bob Collis and James Hayward, my loving family and partner Fiona for all her love and support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The author also would like to place on record his thanks to the many Second World War veterans of Britain, America, France, Belgium, Holland and Germany and their families who have shared their wartime stories, letters, memoirs and photographs with him over the years.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0vii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("‘The August Moon’")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Punch")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("21 August 1940.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a290636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0